import styled from "styled-components"
import {Modal} from "react-bootstrap"

const DescriptionModal = styled(Modal)`
  .modal-content {
    height: 370px;
    position: relative;
    top: 50px;
    padding: ${({theme}) => `${theme.spacing.eight} ${theme.spacing.four}`};
  }
`

export default DescriptionModal
